import i18n from 'i18next';
import Backend from 'i18next-fetch-backend';
import {initReactI18next} from 'react-i18next';
import getI18NextOptions from './i18NextOptions';
import LanguageDetector from 'i18next-browser-languagedetector';
import {getLanguageFromPath} from 'shared/src/helpers/pathHelper';
import {getPreloadedI18n} from '../modules/ssrHelper';

export default function initI18n(siteId) {
    // Start in the language the server rendered, with the translations it embedded in the page,
    // so the first render is synchronous (no Suspense fallback replacing the SSR markup)
    // and other languages are only fetched when the user switches to them.
    const preloadedI18n = getPreloadedI18n();

    const options = {
        ...getI18NextOptions(siteId),
        lng: preloadedI18n ? preloadedI18n.lng : getLanguageFromPath(window.location.pathname),
        ...(preloadedI18n ? {
            resources: preloadedI18n.resources,
            partialBundledLanguages: true,
        } : {}),
    };

    return i18n
        .use(LanguageDetector)
        .use(Backend)
        .use(initReactI18next)
        .init(options);
}
